module.exports = __webpack_public_path__ + "img/banner-18.a0ea1427.jpg";